import axios from "axios";
import {ResponseItem, ResponseRemove} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {KPFile} from "../../models/serverModels/archive/KPFile";

const rootApi = process.env.REACT_APP_API_KEY;

const archiveFile = axios.create({
  baseURL: rootApi,
});

export const create = async (params: Params.Create<KPFile>): Promise<ResponseItem<KPFile>> =>
  archiveFile({
    url: `/File/`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  archiveFile({
    url: `/File/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);
